var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.image)?_c('v-img',_vm._g(_vm._b({staticClass:"mb-6",attrs:{"height":"200","src":_vm.image},on:{"error":_vm.showDefaultImg}},'v-img',_vm.$attrs,false),_vm.$listeners)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }